<template>
    <div>
        <a-modal :visible="visible" title="同步IOT信息" width="40%" centered okText="确认" cancelText="取消"
            :destroyOnClose="true" @ok="() => onSubmit()" @cancel="() => hideDialog()">
            <a-form-model layout="horizontal" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" :rules="rules"
                :model="form" ref="form">
                <a-form-model-item label="区域信息" prop="identifier">
                    <span>{{ form.name }}</span>
                </a-form-model-item>
                <a-form-model-item label="同步类型" prop="types">
                    <a-checkbox-group v-model="form.types" :options="plainOptions" />
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>
<script>
export default {
    name: 'RegionRefreshModal',
    components: {},
    mounted() { },
    data() {
        return {
            rules: {
                types: [{ required: true, message: '同步类型不能为空', trigger: 'change' }],
            },
            plainOptions: [{ label: '产品物模型', value: 1 }, { label: '负载设备类型', value: 2 }, { label: '固件编号', value: 3 }, { label: '中控型号功能关联', value: 4 }],
            visible: false,
            form: {
                identifier: '',
                name: '',
                types: [],
            },
        };
    },
    methods: {
        hideDialog() {
            this.visible = false;
            this.form.identifier = '';
            this.form.types = [];
            this.form.name = '';
        },
        showRefreshDialog(params) {
            this.form.identifier = params?.identifier;
            this.form.name = params?.name;
            this.visible = true;
        },
        save() {
            this.$refs.form.validate((relsValid) => {
                if (relsValid) {
                    this.$apiManager.region.refreshRegionIotInfo(this.form).then(() => {
                        this.$message.success('同步成功');
                        this.hideDialog();
                        this.$parent.listRegions();
                    });
                }
            });
        },
        onSubmit() {
            this.save();
        },
    },

};
</script>
